// is ISO date

export default value =>
	typeof value === 'string' &&
	value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/);
